import {ComponentFactoryResolver, Injector, StaticProvider} from "@angular/core";

export interface IModalOptions {
  /**
   * Event before closing modal
   */
  beforeClose?: () => Promise<void>;

  /**
   * Provide special component injector bindings
   */
  bindings?: StaticProvider[];
  /**
   * Close modal on ESC
   * Default values:
   * for windowTheme=="default" - true,
   * for windowTheme=="content" - false
   */
  escape?: boolean;

  /**
   * Specific window class name
   * @Obsolete use windowTheme option
   */
  windowClass?: string;

  /**
   * Open modal in stashed mode (invisible)
   */
  stashed?: boolean;

  /**
   * Own injector to create window component
   */
  injector?: Injector;

  /**
   * Use this resolver to create modal component
   */
  resolver?: ComponentFactoryResolver;

  /**
   * Do not set z-index as inline style automatically.
   */
  manualZIndex?: boolean;

  /**
   * Class on body when modal is open
   */
  openBodyClass?: string;

  /**
   * Modal window theme
   */
  windowTheme?: ModalWindowTheme;

  /**
   * It effects only on class names adding
   */
  dontMarkAsLast?: boolean;
}

/**
 * Window style
 * Use content to open new modal layer behind all page
 * Use default to open modal
 */
export type ModalWindowTheme = "default" | "content" | "dialog";


export function needToShowBackdrop(options: IModalOptions): boolean {
  /*
   if (!options || !options.windowTheme) return true;
  return options.windowTheme === "default" || options.windowTheme === "dialog";
  */
  return !options || !options.windowTheme || options.windowTheme === "default" || options.windowTheme === "dialog";
}

export function needCloseOnEscape(options: IModalOptions): boolean {
  if (!options) {
    return true;
  }
  if (typeof (options.escape) !== "undefined") {
    return options.escape;
  }
  return !options.windowTheme || options.windowTheme === "default";
}
